export const formatIndustrySkills = (options, selected) => {
  const filtered_options = options.filter(
    ({ id: idOptions }) => selected.some(idSelected => idSelected === idOptions) // es6 function that filters array of objects that exists in both arrays
  )
  let value = []
  filtered_options.map(opt => {
    value = [...value, ...opt.skills]
  })
  return value
}
